export default __webpack_public_path__ + "static/media/ShaftsImg.ca69b052.jpg";